import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/core/styles";
import { Header } from "./components/Header.jsx";
import Advanced from "./servicetypes/Advanced.jsx";
import Interactive from "./servicetypes/Interactive.jsx";
import AreaBased from "./servicetypes/AreaBased.jsx";
import "core-js";

export default class Service extends React.Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  getServiceJson = () => {
    return this.state.moduleGroup;
  };

  fetchData = () => {
    if (window.top.ivrJson && window.top.isPreview) {
      const moduleGroupData = window.top.ivrJson;
      this.setState({ moduleGroup: moduleGroupData });
    } else {
      fetch(`/services/get_service?moduleGroupId=${this.props.serviceId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((service) => {
          const moduleGroup = JSON.parse(service.response.ModuleGroup);
          this.setState({ moduleGroup });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  };

  fetchSitesData = (token) => {
    if (window.top.sitesList) {
      this.setState({ sites: window.top.sitesList });
      return;
    }
    fetch(`/aurora-api/api/sites/${this.props.clientId}/sites`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((sites) => {
        this.setState({ sites });
      })
      .catch((error) => {
        console.error("Error loading sites for client:", error);
        this.setState({ sites: [{ na: "na" }] });
      });
  };

  componentDidMount = () => {
    let nmLogin = () => {
      return fetch("/getToken", {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((res) => res.response.jwt);
    };

    if (window.top.sitesList && !this.props.serviceVersion) {
      nmLogin = () => Promise.resolve(null);
    }
    nmLogin().then((jwt) => {
      window.top.jwt = jwt;
      this.fetchSitesData(jwt);
      if (this.props.serviceJson) {
        this.setState({ moduleGroup: this.props.serviceJson });
      } else if (this.props.serviceVersion) {
        const url = `/nm-api/api/services/${this.props.serviceId}/history/${this.props.serviceVersion}`;
        fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error("Network response was not ok");
            }
            return res.json();
          })
          .then((response) => {
            fetch(response.data)
              .then((res) => res.json())
              .then((service) => {
                this.setState({ moduleGroup: service }, () => {
                  this.props.onLoadHandler(service);
                });
              });
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        this.fetchData();
      }
    });
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  renderContent = (moduleGroupProp, sites, isSubLevel) => {
    let moduleGroup = moduleGroupProp;
    if (typeof moduleGroupProp === "string") {
      moduleGroup = JSON.parse(moduleGroupProp);
    }
    switch (moduleGroup.service) {
      case "INTERACTIVE":
        return (
          <Interactive
            service={moduleGroup}
            sites={sites}
            renderContent={this.renderContent}
            clientId={this.props.clientId}
            isSubLevel={isSubLevel}
          />
        );
      case "ABR":
        return (
          <AreaBased
            service={moduleGroup}
            sites={sites}
            renderContent={this.renderContent}
            clientId={this.props.clientId}
            isSubLevel={isSubLevel}
          />
        );
      default:
        break;
    }
    return (
      <Advanced
        service={moduleGroup}
        sites={sites}
        clientId={this.props.clientId}
        isSubLevel={isSubLevel}
      />
    );
  };

  render = () => {
    const { moduleGroup } = this.state;
    const { sites } = this.state;
    if (moduleGroup && sites) {
      return (
        <ThemeProvider>
          <div className={this.props.className}>
            {
              <Header
                serviceType={moduleGroup.service}
                isPreview={this.props.isPreview}
              />
            }
            <span className="serviceConfig-container">
              {this.renderContent(moduleGroup, sites)}
            </span>
          </div>
        </ThemeProvider>
      );
    }
    return (
      <div
        style={{
          height: "300px",
          textAlign: "center",
          verticalAlign: "middle",
        }}
      >
        <img src="/_client/images/global/ui-loader-1.gif" />
      </div>
    );
  };
}

Service.propTypes = {
  serviceJson: PropTypes.obj,
  jwt: PropTypes.string,
  serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serviceVersion: PropTypes.string,
  onLoadHandler: PropTypes.func,
  ivrJson: PropTypes.obj,
  className: PropTypes.string,
  isPreview: PropTypes.bool, // I think?
};
